import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
}), 'Videocam');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Videocam.js
// module id = 7050
// module chunks = 2